<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" :style="colors">
            <div class="modal">
                <div class="modal-head">
                    <slot name="header">
                    </slot>
                    <button
                        v-if="showModal"
                        @click="close"
                        class="modal_close_btn"
                    >
                        <inline-svg
                            :src="close_icon"
                        />
                    </button>
                </div>
                <div class="modal-body">
                    <slot name="body">
                    </slot>
                </div>
                <div class="modal-footer">
                    <slot name="footer">
                    </slot>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import { mapGetters } from 'vuex';
    import close_icon from '@/assets/icons/close.svg';
    export default {
        data() {
            return {
                close_icon
            }
        },
        methods: {
            close() {
                this.$emit('close');
            }
        },
        computed: {
            ...mapGetters([
                'getSessionDetails'
            ]),
            colors() {
                return {
                    '--primary-color': `#${this.getSessionDetails.editorSetup.colors.primaryColor}`
                }
            }
        },
        props: ['showModal']
    }
</script>

<style>
    .modal-backdrop {
        color: var(--primary-color)
    }
    .modalForm button.form_submit_btn {
        background-color: var(--primary-color);
        color: #ffffff;
    }
    .modal_cancel-btn {
        color: var(--primary-color);
    }
</style>